/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GenericMessageDto } from '../../models/generic-message-dto';
import { LinkVerificationDto } from '../../models/link-verification-dto';

export interface AuthControllerLinkVerification$Params {
  body: LinkVerificationDto;
}

export function authControllerLinkVerification(
  http: HttpClient,
  rootUrl: string,
  params: AuthControllerLinkVerification$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<GenericMessageDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    authControllerLinkVerification.PATH,
    'post',
  );
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GenericMessageDto>;
      }),
    );
}

authControllerLinkVerification.PATH = '/auth/link-verification';
